'use client';

import Image from 'next/image';
import copy from '../_content/site-copy.json';
import { Wordmark } from './Wordmark';
import { EnterLink } from './MuseumTransition';
export function PeriodSkin({
  era,
  paragraphs,
  onSelect
}: {
  era: (typeof copy.eras.options)[number];
  paragraphs: string[];
  onSelect: (id: string) => void;
}) {
  let wordIndex = 0;
  return <section className={`museum-period museum-period-${era.id}`}>
      <div className="museum-period-window">
        <div className="museum-period-bar" aria-hidden="true">
          <span />
          <span>{copy.site.name}</span>
          <span />
        </div>
        <div className="museum-period-content">
          <h1>
            <Wordmark />
          </h1>
          {era.id === 'desktop' && <Image className="museum-desktop-wafer" src="/museum/wafer-halftone.png" alt="" width={930} height={930} />}
          {era.id === 'browser' && <fieldset className="museum-browser-radios">
              <legend>{copy.eras.label}</legend>
              {copy.eras.options.map(option => <label key={option.id}>
                  <input type="radio" name="era" value={option.id} checked={era.id === option.id} onChange={() => onSelect(option.id)} />
                  {option.label}
                </label>)}
            </fieldset>}
          <div className="museum-period-prose">
            {era.id === 'machine' ? <>
                <div className="sr-only">
                  {paragraphs.map(paragraph => <p key={paragraph}>{paragraph}</p>)}
                </div>
                <div aria-hidden="true">
                  {paragraphs.map(paragraph_0 => <p key={paragraph_0}>
                      {paragraph_0.split(' ').map(word => {
                  const index = wordIndex++;
                  return <span key={index} className="museum-stream-word" style={{
                    animationDelay: `${index * 18}ms`
                  }}>
                            {word}{' '}
                          </span>;
                })}
                    </p>)}
                </div>
              </> : paragraphs.map(paragraph_1 => <p key={paragraph_1}>{paragraph_1}</p>)}
          </div>
          <EnterLink />
        </div>
      </div>
    </section>;
}